export class CustomError extends Error {
  message = 'Something went wrong';

  constructor(message: string | undefined) {
    super(message);
    if (message && message !== null && message.length) {
      this.message = message;
    }
  }
}
